
import * as storyblokRuntime$_5kWuwcp643f0xeCyzWPJubJlQeeOv07EQ_45y_45J7ECXxU from '/codebuild/output/src3801724883/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$kwiWfJsMNaQqLYlJ_45_t7IyP_45SVElZZ2ALiEd9aKNl20 from '/codebuild/output/src3801724883/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$_5kWuwcp643f0xeCyzWPJubJlQeeOv07EQ_45y_45J7ECXxU, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$kwiWfJsMNaQqLYlJ_45_t7IyP_45SVElZZ2ALiEd9aKNl20, defaults: {} }
}
        